<slotcom-navigation-button
  type="close"
  (click)="closeRankingInfo()">
</slotcom-navigation-button>

<div
  class="blurred-background"
  [style.opacity]="imgLoaded()">
  <div class="info-container">
    <slotcom-p
      class="title"
      [bold]="true"
      [text]="'home.ranking.info.how' | translate"
      [shadowBorder]="true"></slotcom-p>
    <div class="img-section">
      <div class="first-section">
        <img
          imgLoadedCompleted
          [src]="slot"
          class="slot" />
      </div>
      <img
        imgLoadedCompleted
        [src]="arrow"
        class="arrow" />
      <div class="second-section">
        <img
          imgLoadedCompleted
          [src]="ranking"
          class="ranking" />
      </div>
      <img
        imgLoadedCompleted
        [src]="arrow"
        class="arrow" />
      <div class="third-section">
        <img
          imgLoadedCompleted
          [src]="prize"
          class="prize" />
      </div>
      <img
        imgLoadedCompleted
        [src]="glow"
        class="glow" />
    </div>
    <div class="text-section">
      <slotcom-p
        class="content"
        [bold]="true"
        [text]="'home.ranking.info.info-01' | translate"
        [shadowBorder]="true"></slotcom-p>
      <slotcom-p
        class="content"
        [bold]="true"
        [text]="'home.ranking.info.info-02' | translate"
        [shadowBorder]="true"></slotcom-p>
      <slotcom-p
        class="content"
        [bold]="true"
        [text]="'home.ranking.info.info-03' | translate"
        [shadowBorder]="true"></slotcom-p>
    </div>
  </div>
</div>
